import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Download } from "lucide-react";

import { addBulkProduct } from "src/api/inventory";
import { FileDropzone } from "src/components/form";
import { Button } from "src/components/ui/button";
import { usePortalContext } from "src/context/PortalContext";
import { showSuccessToast } from "src/lib/utils";

const UploadProductsModal = () => {
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const [file, setFile] = useState<File | null>(null);

	const { mutate, isLoading } = useMutation(addBulkProduct, {
		onSuccess: () => {
			showSuccessToast("Product file added successfully");
			queryClient.invalidateQueries(["inventory"]);
			closePortal();
		},
	});

	const handleSubmit = () => {
		if (!file) return;

		const formData = new FormData();
		formData.append("file", file);
		mutate(formData);
	};

	return (
		<div className="tw-grid tw-gap-4">
			<FileDropzone
				file={file}
				onFileChange={setFile}
				accept=".xlsx,.xls,.csv"
				hint="Upload a spreadsheet with one product per row. Use the sample below for the expected columns."
			/>

			<a
				href="./sample-products.xlsx"
				download
				className="tw-inline-flex tw-w-fit tw-items-center tw-gap-1.5 tw-text-[13px] tw-font-medium tw-text-teal hover:tw-underline"
			>
				<Download className="tw-size-4" />
				Download sample
			</a>

			<Button variant="secondary" type="button" className="tw-w-full" onClick={handleSubmit} disabled={isLoading || !file}>
				{isLoading ? "Uploading..." : "Upload"}
			</Button>
		</div>
	);
};

export default UploadProductsModal;
